import React, { useState } from 'react';
import { Box, Typography, Switch, FormControlLabel, Button, Stack, Alert, TextField } from '@mui/material';

const Notifications = () => {
  const [lowStock, setLowStock] = useState(false);
  const [salesSummary, setSalesSummary] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);


  // Load notification settings from backend
  React.useEffect(() => {
    fetch('/api/settings/notifications')
      .then(res => res.json())
      .then(data => {
        setLowStock(!!data.lowStock);
        setSalesSummary(!!data.salesSummary);
        setEmail(data.email || '');
      });
  }, []);

  const handleSave = async () => {
    setLoading(true);
    setMessage(null);
    try {
      const res = await fetch('/api/settings/notifications', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lowStock, salesSummary, email })
      });
      if (res.ok) {
        setMessage({ type: 'success', text: 'Notification settings saved.' });
      } else {
        const data = await res.json();
        setMessage({ type: 'error', text: data.error || 'Failed to save settings.' });
      }
    } catch {
      setMessage({ type: 'error', text: 'Failed to save settings.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stack spacing={2}>
        <FormControlLabel
          control={<Switch checked={lowStock} onChange={e => setLowStock(e.target.checked)} />}
          label="Enable low stock alerts"
        />
        <FormControlLabel
          control={<Switch checked={salesSummary} onChange={e => setSalesSummary(e.target.checked)} />}
          label="Enable sales summary emails"
        />
        {salesSummary && (
          <TextField
            label="Summary Email Address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            fullWidth
          />
        )}
        <Button variant="contained" onClick={handleSave} disabled={loading}>Save</Button>
        {message && <Alert severity={message.type}>{message.text}</Alert>}
      </Stack>
    </Box>
  );
};

export default Notifications;
